export default "__VITE_ASSET__iFUD2dSt__"